import { render, staticRenderFns } from "./GatheringList.vue?vue&type=template&id=235c3a90"
import script from "./GatheringList.vue?vue&type=script&lang=js"
export * from "./GatheringList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports